// @ts-ignore
import styles from './ToggleButtons.module.scss';
import React from 'react';
import useTranslation from '../../Hooks/useTranslation';
import { ToggleButtonsOption } from '../../Modules/DENT/Interfaces/SelectModal.interface';
import { ToggleButtonView } from '../../Enums/ToggleButtonView.enum';
import { joinClasses } from '../../Utils/className.util';

interface Props<T extends ToggleButtonsOption> {
	options: T[];
	selectedOption?: T;
	onChange: (option: T) => void;
	view?: ToggleButtonView;
}

const ToggleButtons = <T extends ToggleButtonsOption>({
	options,
	selectedOption,
	onChange,
	view = ToggleButtonView.HORIZONTAL,
}: Props<T>) => {
	const { t } = useTranslation();

	return (
		<div className={joinClasses([styles.subMenuContainer, styles[view]])}>
			{options.map(option => (
				<span
					key={option.value}
					className={`${styles.menuOption} ${
						selectedOption?.value === option.value ? styles.selected : ''
					}`}
					onClick={() => onChange(option)}>
					{t(option.label)}
				</span>
			))}
		</div>
	);
};

export default ToggleButtons;
